<template>
    <x-navigation-overlay id="navigation-overlay" v-model="menuOpen">
                    <x-list>
                        <x-list-tile @click="closeNavigation()">
                            <router-link :to="dashboardLink">Dashboard</router-link>
                        </x-list-tile>
                        <x-list-tile v-if="getAQuote"  @click="closeNavigation()">
                            <router-link to="/agent/contract/new">Get quotes</router-link>
                        </x-list-tile>
<!--                        <x-list-tile v-if="showEventsAndTasks" @click="closeNavigation()">-->
<!--                            <router-link to="/events/dashboard">Events and Tasks</router-link>-->
<!--                        </x-list-tile>-->
<!--                        <x-list-tile v-if="showBasicTasksDashboard" @click="closeNavigation()">-->
<!--                            <router-link to="/basic/tasks/dashboard">Tasks dashboard</router-link>-->
<!--                        </x-list-tile>-->
                        <x-list-tile v-if="$root.userCan('view facility')" @click="closeNavigation()">
                            <router-link to="/agent/facility-manager">Facility manager</router-link>
                        </x-list-tile>
                        <x-list-tile v-if="$root.userCan('view securities')" @click="closeNavigation()">
                            <router-link :to="dashboardSecuritiesLink">Security manager</router-link>
                        </x-list-tile>
                        <x-list-tile v-if="$root.userCan('view contact management')" @click="closeNavigation()">
                            <router-link to="/agent/contact-management">Contact management</router-link>
                        </x-list-tile>
<!--                        <x-list-tile v-if="userIsInsurer" @click="closeNavigation()">-->
<!--                            <router-link to="/insurer/reports">Reports</router-link>-->
<!--                        </x-list-tile>-->
<!--                        <x-list-tile v-if="!userIsInsurer" @click="closeNavigation()">-->
<!--                            <router-link to="/agent/reports">Reports</router-link>-->
<!--                        </x-list-tile>-->
                        <x-list-tile @click.native="logout()">
                            <a>Logout</a>
                        </x-list-tile>
                    </x-list>
    </x-navigation-overlay>
</template>

<script>
    export default {
        props: ['menuOpen'],
        computed: {
            dashboardLink() {
                return this.userIsInsurer ? '/insurer/dashboard/' : '/agent/dashboard/';
            },
            dashboardSecuritiesLink() {
                return this.userIsInsurer ? '/insurer/security-manager/' : '/broker/security-manager/';
            },
            getAQuote() {
                return !this.$root.userIsInsurer;
            },
            userIsPlacingBroker() {
                return this.$root.userIsPlacingBroker;
            },
            userIsInsurer() {
                return this.$root.userIsInsurer;
            },
            showEventsAndTasks() {
                return this.$root.usingAdvancedActivitiesFramework() && (this.$root.userCan('view tasks') || this.$root.userCan('view oiis') || this.$root.userCan('view events'));
            },
            showBasicTasksDashboard() {
                return this.$root.usingBasicActivitiesFramework() && (this.$root.userCan('view tasks'));
            }
        },
        methods: {
            logout() {
                this.$hyperionAuth.logout();
            },
            closeNavigation() {
                this.$emit('closeNav');
            }
        }
    }
</script>

<style lang="scss" scoped>
.x-navigation-overlay {
    z-index: 4 !important;
    font-family: $font-title;

    .x-list {
        div[role=listitem] {
            :deep(.x-list__tile) {
                &:hover {
                     background-color: transparent;
                     color: $color-pistachio;
                }

                a {
                    font-weight: 400;

                    &:hover {
                        color: $color-pistachio !important;
                    }
                }
            }
        }
    }
}
</style>
